export type VariantBodyType = 'body1' | 'body2';

export enum Breakpoint {
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
  XL = 'xl',
  XS = 'xs',
}
export type BreakpointRecord = Partial<Record<Breakpoint, string>>;

export enum NormalizedSpacingKey {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}
export enum SpacingKey {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top',
  X = 'x',
  Y = 'y',
}
export enum SpacingType {
  Margin = 'margin',
  Padding = 'padding',
}
export type SpacingValue = BreakpointRecord | string;
export type SpacingRecord = Partial<Record<SpacingKey, SpacingValue>>;
export type NormalizedSpacingRecord = Partial<Record<NormalizedSpacingKey, SpacingValue>>;
export type Spacing = SpacingRecord | SpacingValue;

export enum MarginKey {
  Bottom = 'marginBottom',
  Left = 'marginLeft',
  Right = 'marginRight',
  Top = 'marginTop',
}
export type MarginRecord = Partial<Record<MarginKey, SpacingValue>>;

export enum PaddingKey {
  Bottom = 'paddingBottom',
  Left = 'paddingLeft',
  Right = 'paddingRight',
  Top = 'paddingTop',
}
export type PaddingRecord = Partial<Record<PaddingKey, SpacingValue>>;

export enum COLOR {
  Black = 'black',
  Dark1 = 'dark1',
  Dark2 = 'dark2',
  Dark3 = 'dark3',
  Gold1 = 'gold1',
  Gold2 = 'gold2',
  Gray1 = 'gray1',
  Gray2 = 'gray2',
  Gray3 = 'gray3',
  Highlight = 'highlight',
  White = 'white',
}
